// Filter state for the Accounts screen (Company / Customer / Vouchers).
//
// Keys are flat and prefixed by tab rather than nested per tab. Both filter
// guards read them by name: the pre-commit scan in scripts/check-filter-coverage.js
// matches `v-model="filters.<key>"` and would not see a dotted path at all, and
// filterChipsMixin's runtime guard compares each top-level key against its
// default, so a nested object would only ever report the parent as unchipped.
//
// Dates live here rather than in component data() for the same reason: on the
// old screen they were component-local, so they vanished on navigation and were
// invisible to the coverage guard.
const initialState = () => ({
  // Structural: shared by every tab.
  page: 1,
  selected_tab: 0,

  // Company
  company_view: "ledger", // "ledger" | "group"
  company_path: [], // [{ level, id, name }] -- the cascade selection
  company_date_range: [],
  company_display_date: "",
  company_voucher_name: [],
  company_entry_side: "",
  company_product_type: [], // product names, multi-select

  // Customer
  customer_product_type: [], // product names, multi-select
  // Borrower Company: the borrower's employer, typed free-hand
  customer_employer_name: "",
  customer_date_range: [],
  customer_display_date: "",
  customer_ledger: null, // whole object: the voucher dialogs read fields off it

  // Vouchers
  voucher_date_range: [],
  voucher_display_date: "",
  voucher_lead_creation: "",
  voucher_ledger: null,
  voucher_product_type: [], // product names, multi-select
  voucher_entry_side: "",
  voucher_name: [],
  voucher_manual_entry_type: [],
  voucher_status: "",
});

// Which keys belong to which tab, so one tab's "Clear all" leaves the others
// alone -- and so it cannot reset selected_tab and bounce the user to Company
// in the middle of their work.
const TAB_PREFIX = ["company_", "customer_", "voucher_"];

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
    RESET_TAB_FILTERS(state, tab) {
      const prefix = TAB_PREFIX[tab];
      if (!prefix) return;
      const defaults = initialState();
      Object.keys(defaults).forEach((key) => {
        if (key.startsWith(prefix)) state[key] = defaults[key];
      });
      state.page = 1;
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
    resetTabFilters({ commit }, tab) {
      commit("RESET_TAB_FILTERS", tab);
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
